export const COMPANY_DOCUMENTS_EDIT_PATH =
  "/documents/company/edit/:documentId/:tab?";
